<template>
  <div class="editPass">
    <div class="top">
      <van-icon size="22px" name="arrow-left" @click="back" />
      <span class="title">{{ $t('append_field.reset_password')}}</span>
    </div>
    <div class="error-msg">{{$t('append_field.msg_password')}}</div>
    <div class="editPass-body">
      <van-cell-group>
        <van-field
            :clearable="true"
            v-model="userName"
            :placeholder="$t('append_field.enter_username')"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.userName') }}
          </template>

        </van-field>
        <van-field
            :clearable="true"
            v-model="newpass"
            :placeholder="$t('append_field.enter_new_password')">
          <template #label>
            <span class="required">*</span> {{ $t('append_field.new_password') }}
          </template>
        </van-field>
        <van-field
            :clearable="true"
            v-model="conpass"
            :placeholder="$t('append_field.enter_new_password_again')"
        >
          <template #label>
            <span class="required">*</span> {{ $t('append_field.confirm_password') }}
          </template>
        </van-field>
          <van-field
              v-model="keycodeLogin"
              :clearable="true"
              :placeholder="$t('append_field.input_code')"
          >
            <template #label>
              <span class="required">*</span> {{ $t('append_field.verification_code') }}
            </template>
            <template #button>
              <codeKey ref="codeKey" slot="append" @update:uuid="setUuid" style="display: flex;align-items: center;justify-content: center" ></codeKey>
            </template>
          </van-field>
      </van-cell-group>
      <div class="editPass-msg">{{error}}</div>
      <div class="editPass-btn">
        <van-button block color="#006EFF" @click="onSubmit">
          {{$t('append_field.confirm')}}
        </van-button>
      </div>
    </div>
    <van-dialog  v-model="isPassVerify" :title="diaTitle[type]"
                 show-cancel-button
                 @confirm="uuidLogin"
                 :beforeClose="vBeforeClose"
                 @cancel="close()">
      <div class="passVerify-content">
        <div class="passVerify-explain">{{$t('append_field.please_authenticate_for_account_safety')}}</div>
        <div class="passVerify-email">
          <span>{{ passBind }}</span>
          <div class="passVerify-opt" v-if="environment=='local'">
            <van-button v-if="type===1"
                        v-show="showButton"
                        style="
            color: #00a2fe;
            border: none;
            background-color:transparent;"
                        @click="selectedOption(0)">
              {{$t('append_field.phone_number')}}
            </van-button>
            <van-button v-if="type===0"
                        v-show="showButton"
                        style="
            color: #00a2fe;
            border: none;
            background-color:transparent;"
                        @click="selectedOption(1)">
              {{$t('append_field.email')}}
            </van-button>
          </div>
        </div>
        <div class="passVerify-code">
          <input type="number" v-model="uuidCode" >
          <van-button :disabled="getCodeing" color="#006EFF" @click="getUuidCode()" >{{ uuidCodeText }}</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import qs from "qs";
import {Toast} from "vant";
import codeKey from "@/components/Vsidentify.vue";
import CryptoJS from 'crypto-js'
import {environment} from "@/assets/js/user_environment";
import {vBeforeClose} from "@/utils/tool";
function encrypt(data) {
  var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
  key = CryptoJS.enc.Hex.parse(key)
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
  var enc = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  var enced = enc.ciphertext.toString()
  return enced
}
export default {
  components: {codeKey},
  data() {
    return {
      keycodeLogin:'',
      identifyCode:'',
      input: "",
      error: '',
      userName: '',
      newpass:"",
      conpass:"",
      showPassword: false, // 控制密码可见性的布尔变量
      showPassword2:false,
      passwordFieldType: 'password', // 密码输入框的类型
      passwordFieldType2: 'password', // 密码输入框的类型
      topTitle: this.$t('append_field.login'),
      show: true,
      isPassVerify: false,
      passBindPhone: "",
      uuid: "",
      uuidCode: "",
      uuidCodeText: this.$t('append_field.verification_code'),
      getCodeing: false,
      platformType:1,
      type: 1,
      showButton: true,
      passBind: '',
      rememberMe:false,
      diaTitle:[this.$t('append_field.sms_verification'),this.$t('append_field.email_verification')],
      newUuid:'',
      environment
    }
  },
  created() {
    this.Flush()
    try {
      const { username,phone,email} = this.$route.query
      this.userName = username
      this.passBind = email
      this.email = email
      this.passBindPhone= phone
    }catch (e) {
      console.log(e)
    }
  },
  methods: {
    vBeforeClose,
    //获取uuid
    setUuid(newUuid) {
      this.newUuid = newUuid
    },
    Flush() {
      this.identifyCode = ''
      for (let i = 0; i < 4; i++) {
        this.identifyCode += parseInt(Math.random() * 10)
      }
    },
    /*弹框*/
    close(){
      this.isPassVerify=false
      this.uuidCode=""
    },
    uuidLogin() {
      if(this.uuidCode==''){
        Toast(this.$t('append_field.get_code'),'fail')
      }
      this.$ajax({
        url: '/etv/updateForgetPassword.json',
        method: 'post',
        cache: false,
        params: {
          'code': this.uuidCode,
          'password': encrypt(this.newpass),
          'account': encrypt(this.userName),
          'verifyType': this.type,
        }
      }).then(res => {

        let code = res.data.code
        let msg = res.data.msg
        if (code === 0) {
          Toast(msg)
          this.$router.push({path:'/login'})
          localStorage.clear()
          //this.isPassVerify=false
        }else{
          this.isPassVerify=true
          Toast(msg,'fail')
        }
      })
    },
    selectedOption(option) {
      this.type = option
      //let verifyFlag= this.verifyFlag
      this.showButton = true
      if (this.type === 0) {
        this.passBind = this.passBindPhone
      } else {
        this.passBind = this.email
      }
    },
    //获取验证码
    getUuidCode() {

      this.$ajax.post('/etv/getVerifyCode.json',
          qs.stringify({
            account: this.userName,
            verifyType: this.type,
            verifyCode: this.keycodeLogin,
            uuid: this.newUuid
          })
      ).then(res => {
        if (res.data.code === 0) {
          if (this.getCodeing) {
            return
          }
          this.getCodeing = true
          let i = 60
          this.uuidCodeText = `${i}`+'s'
          let timer = setInterval(() => {
            i--
            this.uuidCodeText = `${i}`+'s'
            if (i === 0) {
              this.getCodeing = false
              timer && clearInterval(timer)
              this.uuidCodeText = this.$t('append_field.verification_code')
            }
          }, 1000)
          Toast(res.data.msg)
        } else {
          this.$refs.codeKey.getCode()
          Toast(res.data.msg,'fail')
        }
      })
    },
    /*弹框end*/
    onSubmit() {
      this.error = ""
      const reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[@#$%^&+=]).{8,}$/
      if (!reg.test(this.newpass)) {
        this.error = `(${this.$t('append_field.please_enter_password')})`
        return
      }
      if(this.newpass !== this.conpass){
        this.error = `(${this.$t('append_field.passwords_do_not_match')})`
        return
      }
      if(!this.userName){
        this.error = this.$t('append_field.username_not_exist')
        return
      }
      if(!this.keycodeLogin){
        Toast(this.$t('append_field.fill_code'),'fail')
        return;
      }
      this.isPassVerify = true
      if (this.email === '') {
        this.type=0
        this.passBind=this.passBindPhone
        this.showButton=false
      } else if(this.passBindPhone === ''){
        this.type=1
        this.passBind=this.email
        this.showButton=false
      }
    },
    togglePassword(num){
      if(num === 1){
        // 切换密码的可见性
        this.showPassword = !this.showPassword
        // 根据密码的可见性状态切换输入框的类型
        this.passwordFieldType = this.showPassword ? 'text' : 'password'
      }else{
        // 切换密码的可见性
        this.showPassword2 = !this.showPassword2
        // 根据密码的可见性状态切换输入框的类型
        this.passwordFieldType2 = this.showPassword2 ? 'text' : 'password'
      }
    },
    back() {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
html {
  font-size: 19px; /* 这是默认的字体大小，您可以根据需要调整它 */
}

@media (max-width: 600px) { /* 对于小屏幕设备，您可以减小字体大小 */
  html {
    font-size: 16px;
  }
}

.editPass {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .top{
    padding:18px 10px;
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    justify-content: center; /* 水平居中对齐 */
    position: relative; /* 使子元素可以相对于父元素定位 */
    border-bottom: #8c8c8c 1px solid;

    .van-icon {
      position: absolute; /* 绝对定位 */
      left: 10px; /* 根据需要调整左边距 */
    }
    .title{
      font-size: 18px;
      font-size: 18px;
      float: none; /* 确保不使用浮动 */
      display: inline-block; /* 使元素成为行内块级元素 */
    }
  }
  .error-msg {
    height: 60px;
    font-size:  15px;
    color: red;
    padding:5px 0 0 16px;
  }
  .editPass-header {
    display: flex;

  }
  .editPass-body {

    .van-cell{
      display: flex;
      flex-direction: column;
    }

    .required{
      color: #ff0000;
    }
    ::v-deep .s-canvas{
      width: 100%;
    }

    .ps {
      color: red;
      font-size: 20px;
    }
    .van-field::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);

    }
    .van-field--focused::after {
      border-bottom-color: #409EFF; /* 您可以更改为您喜欢的颜色 */
    }
    ::v-deep .van-field__label{
      width: auto;
    }
    .editPass-msg{
      padding:0 20px;
      height: 50px;
      color: #ff0000;
    }
    .editPass-btn{
      padding: 10px 40px;

    }


  }
}
</style>
